import React from 'react';
import { useSelector } from 'react-redux';

import initGA from 'utils/ga';

import BrandRoutes from 'routes/Brand';
import CheckoutRoutes from 'routes/Checkout';
import { BrandContext, brands, DEFAULT_BRAND } from 'utils/brand-context';

function App() {
  const user = useSelector((state) => state.auth.user);
  initGA(process.env.REACT_APP_GA_TRACKING_ID, user?.id);

  const adminDashboardUrl = process.env.REACT_APP_ADMIN_DASHBOARD_URL;

  if (
    !window.Cypress &&
    window.location.hostname.indexOf('javelinhq.com') === -1
  )
    return <div>Please restart server on *.javelinhq.com</div>;

  const [subdomain] = window.location.hostname.split('.');

  if (subdomain === 'checkout') {
    return (<div className='font-checkout'>
      <CheckoutRoutes />
    </div>)
  }

  if (!window.Cypress && adminDashboardUrl) {
      window.location.href = adminDashboardUrl;
      return null;
  }

  return (
    <BrandContext.Provider value={brands[subdomain] || DEFAULT_BRAND}>
      <BrandRoutes subdomain={subdomain} />
    </BrandContext.Provider>
  );
}

export default App;
